// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   getBranches,
//   fetchRoles,
//   submitCustomer,
// } from "../redux/slices/Customer/CreateCustomerSlice";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import "../assets/css/customerForm.css";
// import { FaCheckCircle, FaSpinner } from "react-icons/fa";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { fetchCompanyAssignedApis } from "../redux/slices/assignedApiSlice";

// const fetchAddressByPincode = async (pincode) => {
//   if (!/^\d{6}$/.test(pincode)) return null;

//   try {
//     const res = await fetch(
//       `https://payyug.in/api/customer/pincode/${pincode}`,
//     );

//     const response = await res.json();

//     console.log("PINCODE RESPONSE:", response);

//     // ✅ Get PostOffice array
//     const offices = response?.PostOffice;

//     // ✅ Validate response
//     if (!offices || offices.length === 0) {
//       return null;
//     }

//     return {
//       postOfficeList: offices,
//       district: offices[0]?.District || "",
//       subDistrict: offices[0]?.Block || "",
//       state: offices[0]?.State || "",
//       country: offices[0]?.Country || "",
//     };
//   } catch (error) {
//     console.log("Pincode Fetch Error:", error);

//     return null;
//   }
// };

// const fetchBankByIFSC = async (ifsc) => {
//   if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) return null;
//   try {
//     const res = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
//     if (!res.ok) return null;
//     const data = await res.json();
//     // console.log("bank details;",data)
//     return { bankName: data.BANK, bankBranch: data.BRANCH };
//   } catch {
//     return null;
//   }
// };

// const CustomerForm = () => {
//   const dispatch = useDispatch();
//   const { branches, roles, loadingSubmit } = useSelector(
//     (state) => state.customer,
//   );
//   const { profile } = useSelector((state) => state.userProfile);
//   const { assignedApis } = useSelector((state) => state.assignedApi||{});

//   const [formData, setFormData] = useState({});
//   const [errors, setErrors] = useState({});
//   const [firstErrorField, setFirstErrorField] = useState(null);
//   const [postOfficeList, setPostOfficeList] = useState([]);
//   const [verifying, setVerifying] = useState({
//     panNumber: false,
//     aadhaarNumber: false,
//   });

//   const [verified, setVerified] = useState({
//     panNumber: false,
//     aadhaarNumber: false,
//   });

//   const firstErrorRef = useRef(null);

//   useEffect(() => {
//     dispatch(getBranches());
//     dispatch(fetchRoles());
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // fetch assigned apis
//   useEffect(() => {
//     if (profile?.superAdminId) {
//       dispatch(fetchCompanyAssignedApis(profile.superAdminId));
//     }
//   }, [dispatch, profile?.superAdminId]);

//   useEffect(() => {
//     // scroll to the first error when firstErrorField changes
//     if (firstErrorField && firstErrorRef.current) {
//       firstErrorRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });
//     }
//   }, [firstErrorField]);

//   // helper function for check specific assign apis active or not
//   const isServiceActive = (serviceKey) => {
//     const service = assignedApis?.find(
//       (item) => item?.serviceName?.toLowerCase() === serviceKey.toLowerCase(),
//     );
//     return Boolean(
//       service &&
//       (service.isEnabled === true ||
//         String(service.status).toLowerCase() === "active"),
//     );
//   };

//   const isPanActive = isServiceActive("PAN_API");
//   const isAadhaarActive = isServiceActive("AADHAR_API");

//   const handleChange = async (e) => {
//     const { name, value } = e.target;

//     // restrictions
//     if (name === "pincode" && value.length > 6) return;
//     if (name === "mobileNumber" && value.length > 10) return;
//     if (name === "aadhaarNumber" && value.length > 12) return;
//     if (name === "panNumber" && value.length > 10) return;

//     // ❗ Fields you want in uppercase
//     const upperCaseFields = [
//       "panNumber",
//       "ifsc",
//       // "fullName",
//       // "guardianName",
//       // "district",
//       // "state",
//       // "country",
//       // "subDistrict",
//       // "bankName",
//       // "bankBranch",
//       // "address",
//     ];

//     const val = upperCaseFields.includes(name) ? value.toUpperCase() : value;

//     setFormData((p) => ({ ...p, [name]: val }));

//     // PINCODE AUTO
//     if (name === "pincode" && val.length === 6) {
//       const addr = await fetchAddressByPincode(val);
//       if (addr) {
//         setPostOfficeList(addr.postOfficeList);
//         setFormData((p) => ({
//           ...p,
//           district: addr.district.toUpperCase(),
//           state: addr.state.toUpperCase(),
//           country: addr.country.toUpperCase(),
//           subDistrict: addr.subDistrict?.toUpperCase() || "",
//           postOffice: "",
//         }));
//       }
//     }

//     // IFSC AUTO
//     if (name === "ifsc") {
//       const bank = await fetchBankByIFSC(val);
//       setFormData((p) => ({
//         ...p,
//         bankName: bank?.bankName?.toUpperCase() || "",
//         bankBranch: bank?.bankBranch?.toUpperCase() || "",
//       }));
//     }
//   };

//   const handlePostOfficeSelect = (e) => {
//     setFormData((p) => ({ ...p, postOffice: e.target.value }));
//   };

//   // Validation
//   const validateForm = () => {
//     const newErr = {};

//     // PAN: 5 letters + 4 digits + 1 letter
//     if (
//       formData.panNumber &&
//       !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(formData.panNumber.trim())
//     ) {
//       newErr.panNumber = "Enter a valid PAN (format: ABCDE1234F).";
//     }

//     // Aadhaar: 12 digits and should not start with 0 or 1
//     if (
//       !formData.aadhaarNumber ||
//       !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber.trim())
//     )
//       newErr.aadhaarNumber =
//         "Enter a valid Aadhaar (12 digits, cannot start with 0 or 1).";

//     // IFSC: optional but validate if present
//     if (formData.ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc.trim()))
//       newErr.ifsc = "Invalid IFSC code.";

//     // Mobile: Indian mobile (starts with 6-9 and 10 digits)
//     if (
//       !formData.mobileNumber ||
//       !/^[6-9][0-9]{9}$/.test(formData.mobileNumber.trim())
//     )
//       newErr.mobileNumber =
//         "Enter a valid 10-digit mobile number (starts with 6-9).";

//     // Bank account: optional but validate if present (9-18 digits)
//     if (
//       formData.bankAccount &&
//       !/^[0-9]{9,18}$/.test(formData.bankAccount.trim())
//     )
//       newErr.bankAccount = "Enter valid bank account number (9-18 digits).";

//     // Pincode: required and 6 digits
//     if (!formData.pincode || !/^[0-9]{6}$/.test(formData.pincode.trim()))
//       newErr.pincode = "Enter a valid 6-digit pincode.";

//     // Required textual fields
//     const requiredFields = [
//       "fullName",
//       "guardianName",
//       "district",
//       "state",
//       "country",
//       "dob",
//       "doj",
//     ];
//     requiredFields.forEach((f) => {
//       if (!formData[f] || String(formData[f]).trim() === "")
//         newErr[f] = "Required field.";
//     });

//     // Email: optional but validate format if provided
//     if (formData.email && !/\S+@\S+\.\S+/.test(formData.email.trim()))
//       newErr.email = "Enter a valid email.";

//     setErrors(newErr);

//     if (Object.keys(newErr).length) {
//       setFirstErrorField(Object.keys(newErr)[0]);
//       return false;
//     }

//     // no errors
//     setFirstErrorField(null);
//     return true;
//   };

//   // const handleSubmit = async () => {
//   //   if (!validateForm()) return;

//   //   const payload = {
//   //     ...formData,
//   //     branchId: profile?.id || formData.branchId || 1,
//   //     branchName: formData.branch || "",
//   //     superAdminId: profile?.superAdminId || 1,
//   //     role: "Customer",
//   //     roleName: "Customer",
//   //     bankIFSC: formData.ifsc || null,
//   //     dateOfBirth: formData.dob,
//   //     dateOfJoining: formData.doj,
//   //     password: "123456",
//   //     pin: "1234",
//   //   };

//   //   // Clean up fields expected by backend
//   //   delete payload.ifsc;
//   //   delete payload.branch;
//   //   delete payload.dob;
//   //   delete payload.doj;

//   //   try {
//   //     const result = await dispatch(submitCustomer(payload)).unwrap();
//   //     alert("✅ Customer submitted successfully!");
//   //     console.log("Response:", result);

//   //     // reset form
//   //     setFormData({
//   //       panNumber: "",
//   //       aadhaarNumber: "",
//   //       branch: "",
//   //       title: "",
//   //       gender: "",
//   //       fullName: "",
//   //       guardianName: "",
//   //       mobileNumber: "",
//   //       email: "",
//   //       pincode: "",
//   //       postOffice: "",
//   //       bankAccount: "",
//   //       ifsc: "",
//   //       bankBranch: "",
//   //       bankName: "",
//   //       subDistrict: "",
//   //       district: "",
//   //       state: "",
//   //       country: "",
//   //       address: "",
//   //       maritalStatus: "",
//   //       dob: "",
//   //       doj: "",
//   //     });
//   //     setErrors({});
//   //     setFirstErrorField(null);
//   //   } catch (err) {
//   //     console.error("❌ Error submitting customer:", err);
//   //     // unwrap error might be object/string; handle gracefully
//   //     const msg = err?.message || err || "Failed to submit customer";
//   //     alert(msg);
//   //   }
//   // };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     const payload = {
//       ...formData,
//       branchId: profile?.id || formData.branchId || 1,
//       branchName: formData.branch || "",
//       superAdminId: profile?.superAdminId || 1,
//       role: "Customer",
//       roleName: "Customer",
//       bankIFSC: formData.ifsc || null,
//       dateOfBirth: formData.dob,
//       dateOfJoining: formData.doj,
//       password: "123456",
//       pin: "1234",
//     };

//     // Clean up unused fields
//     delete payload.ifsc;
//     delete payload.branch;
//     delete payload.dob;
//     delete payload.doj;

//     try {
//       // ⬅ 1. Submit customer API
//       const result = await dispatch(submitCustomer(payload)).unwrap();

//       toast.success("✅ Customer submitted successfully!");
//       console.log("Response:", result);

//       // Extract required fields for SMS
//       const { fullName, userId, mobileNumber } = result?.data || result;

//       // // ⬅ 2. SMS Body
//       // const smsBody = {
//       //   route: "dlt",
//       //   sender_id: "LALSHA",
//       //   message: "180723", // DLT template ID
//       //   variables_values: ${fullName}|${userId}|,
//       //   numbers: mobileNumber,
//       // };

//       // // ⬅ 3. Hit Fast2SMS API
//       // try {
//       //   await axios.post("https://www.fast2sms.com/dev/bulkV2", smsBody, {
//       //     headers: {
//       //       Authorization: "4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8", // Store securely in .env
//       //     },
//       //   });

//       //   console.log("📩 SMS Sent Successfully");
//       // } catch (smsError) {
//       //   console.error(
//       //     "❌ SMS Sending Failed:",
//       //     smsError.response?.data || smsError.message
//       //   );
//       // }

//       // Reset Form after success
//       setFormData({
//         panNumber: "",
//         aadhaarNumber: "",
//         branch: "",
//         title: "",
//         gender: "",
//         fullName: "",
//         guardianName: "",
//         mobileNumber: "",
//         email: "",
//         pincode: "",
//         postOffice: "",
//         bankAccount: "",
//         ifsc: "",
//         bankBranch: "",
//         bankName: "",
//         subDistrict: "",
//         district: "",
//         state: "",
//         country: "",
//         address: "",
//         maritalStatus: "",
//         dob: "",
//         doj: "",
//       });

//       setErrors({});
//       setFirstErrorField(null);
//     } catch (err) {
//       console.error("❌ Error submitting customer:", err);

//       const msg = err?.message || err || "Failed to submit customer";
//       alert(msg);
//     }
//   };

//   const classErr = (f) => (errors[f] ? "CreateEmployee-input-error" : "");
//   const renderError = (f) =>
//     errors[f] ? (
//       <p
//         className="CreateEmployee-error-text"
//         // attach ref only to the first error's element so scrollIntoView works
//         ref={firstErrorField === f ? firstErrorRef : null}
//       >
//         {errors[f]}
//       </p>
//     ) : null;

//   // const handlePostOfficeSelect = (e) => {
//   //   setFormData({
//   //     ...formData,
//   //     postOffice: e.target.value,
//   //   });
//   // };

//   //   const handleVerifyAdhar = async () => {
//   //   const payload = { uid: profile?.superAdminId };

//   //   try {
//   //     const response = await axios.post('https://payyug.in/api/initiate/aadhar', payload);

//   //     const url = response.data?.data?.data?.authorization_url;

//   //     if (url) {
//   //       window.open(url, '_blank', 'noopener,noreferrer');
//   //     } else {
//   //       toast.error(response?.data?.message||"Url doesn't exist.");
//   //     }
//   //   } catch (error) {
//   //     console.error("API Error:", error.response?.data || error.message);
//   //     toast.error(error?.response?.data?.message||"Something went wrong, please try again.");
//   //   }
//   // };

//   const handleVerifyAadhaar = async () => {
//     if (
//       !formData.aadhaarNumber ||
//       !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber)
//     ) {
//       toast.warn("Please enter a valid 12-digit Aadhaar number");
//       return;
//     }
//     setVerifying((p) => ({ ...p, aadhaarNumber: true }));
//     try {
//       const response = await axios.post(
//         "https://payyug.in/api/initiate/aadhar",
//         { uid: profile?.superAdminId },
//       );
//       const url = response.data?.data?.data?.authorization_url;
//       if (url) {
//         window.open(url, "_blank", "noopener,noreferrer");
//         setVerified((p) => ({ ...p, aadhaarNumber: true }));
//         toast.success("Aadhaar verification initiated");
//       } else {
//         toast.error(response?.data?.message || "Url doesn't exist.");
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Something went wrong.");
//     } finally {
//       setVerifying((p) => ({ ...p, aadhaarNumber: false }));
//     }
//   };

//   const handleVerifyPan = async () => {
//     if (
//       !formData.panNumber ||
//       !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panNumber)
//     ) {
//       toast.warn("Invalid PAN format");
//       return;
//     }

//     setVerifying((p) => ({ ...p, panNumber: true }));

//     try {
//       const response = await axios.post(
//         "https://payyug.in/api/verify/pan-new",
//         { adminId: profile?.superAdminId, pan_number: formData.panNumber },
//       );

//       const data = response?.data?.data;

//       if (data) {
//         setFormData((prev) => ({
//           ...prev,
//           fullName: data?.name || prev?.fullName,
//           dob: data?.dob || prev.dob,
//           // pincode: data?.address?.zip || "",
//           gender: data?.gender,
//         }));

//         setVerified((p) => ({ ...p, panNumber: true }));
//         toast.success(response?.data?.message || "PAN Verified");
//       } else {
//         toast.error("No data found for this PAN.");
//       }
//     } catch (error) {
//       console.error("PAN Error:", error);
//       toast.error(error?.response?.data?.error || "Something went wrong.");
//     } finally {
//       setVerifying((p) => ({ ...p, panNumber: false }));
//     }
//   };

//   return (
//     <div className="CustomerForm-wrapper">
//       <form className="CustomerForm" onSubmit={(e) => e.preventDefault()}>
//         <h2 className="form-title">Create New Customer</h2>
//         {/* <div className="verify-btns-wrapper">
//           <button className="">Verify Pan</button>
//           <button className="" onClick={handleVerifyAdhar}>Verify Aadhar</button>
//         </div> */}

//         {/* Personal Info */}
//         <section className="form-section">
//           <h3 className="section-title">Personal Information</h3>

//           <div className="form-grid-2">
//             <div className="verify-wrapper">
//               <label>PAN Number</label>
//               <div className="verify-input-group">
//                 <input
//                   type="text"
//                   name="panNumber"
//                   value={formData.panNumber || ""}
//                   onChange={handleChange}
//                   placeholder="Enter PAN Number"
//                 />
//                 {isPanActive && (
//                   <button
//                     type="button"
//                     className="verify-btn"
//                     onClick={handleVerifyPan}
//                     disabled={
//                       !formData.panNumber ||
//                       verifying.panNumber ||
//                       verified.panNumber
//                     }
//                   >
//                     {verifying.panNumber ? (
//                       <FaSpinner className="spin" />
//                     ) : verified.panNumber ? (
//                       "Verified ✅"
//                     ) : (
//                       <>
//                         <FaCheckCircle /> Verify
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>
//               {renderError("panNumber")}
//             </div>

//             <div className="verify-wrapper">
//               <label>Aadhaar Number</label>
//               <div className="verify-input-group">
//                 <input
//                   type="text"
//                   name="aadhaarNumber"
//                   value={formData.aadhaarNumber || ""}
//                   onChange={handleChange}
//                   placeholder="Enter Aadhaar Number"
//                 />
//                 {isAadhaarActive && (
//                   <button
//                     type="button"
//                     className="verify-btn"
//                     onClick={handleVerifyAadhaar}
//                     disabled={
//                       !formData.aadhaarNumber ||
//                       verifying.aadhaarNumber ||
//                       verified.aadhaarNumber
//                     }
//                   >
//                     {verifying.aadhaarNumber ? (
//                       <FaSpinner className="spin" />
//                     ) : verified.aadhaarNumber ? (
//                       "Verified ✅"
//                     ) : (
//                       <>
//                         <FaCheckCircle /> Verify
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>
//               {verified.aadhaarNumber && (
//                 <div className="verified-data-box">
//                   <h4 className="verified-heading">Aadhaar Verified Data:-</h4>
//                   <div className="verified-grid">
//                     <p>
//                       <strong>Status:</strong> Verified Successfully ✅
//                     </p>
//                   </div>
//                 </div>
//               )}
//               {renderError("aadhaarNumber")}
//             </div>
//           </div>

//           <div className="form-grid-4">
//             <div>
//               <label>Title</label>
//               <select
//                 name="title"
//                 value={formData.title || ""}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Title</option>
//                 <option>Mr.</option>
//                 <option>Mrs.</option>
//                 <option>Ms.</option>
//                 <option>Miss</option>
//                 <option>Dr.</option>
//               </select>
//             </div>

//             <div>
//               <label>Gender</label>
//               <select
//                 name="gender"
//                 value={formData.gender || ""}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Gender</option>
//                 <option>Male</option>
//                 <option>Female</option>
//                 <option>Other</option>
//               </select>
//             </div>
//           </div>
//         </section>

//         {/* Contact & Banking */}
//         <section className="form-section">
//           <h3 className="section-title">Contact & Banking</h3>
//           <div className="form-grid">
//             <div>
//               <label>Full Name</label>
//               <input
//                 name="fullName"
//                 value={formData.fullName || ""}
//                 onChange={handleChange}
//                 className={classErr("fullName")}
//               />
//               {renderError("fullName")}
//             </div>

//             <div>
//               <label>Parent's Name</label>
//               <input
//                 name="guardianName"
//                 value={formData.guardianName || ""}
//                 onChange={handleChange}
//                 className={classErr("guardianName")}
//               />
//               {renderError("guardianName")}
//             </div>

//             <div>
//               <label>Mobile Number</label>
//               <input
//                 name="mobileNumber"
//                 value={formData.mobileNumber || ""}
//                 maxLength="10"
//                 onChange={handleChange}
//                 className={classErr("mobileNumber")}
//               />
//               {renderError("mobileNumber")}
//             </div>

//             <div>
//               <label>Email ID</label>
//               <input
//                 name="email"
//                 type="email"
//                 value={formData.email || ""}
//                 onChange={handleChange}
//                 className={classErr("email")}
//               />
//               {renderError("email")}
//             </div>

//             <div>
//               <label>Pin Code</label>
//               <input
//                 name="pincode"
//                 maxLength="6"
//                 value={formData.pincode || ""}
//                 onChange={handleChange}
//                 className={classErr("pincode")}
//               />
//               {renderError("pincode")}
//             </div>

//             <div>
//               {/* <label>Post Office</label>
//               <input name="postOffice" value={formData.postOffice || ""} onChange={handleChange} />
//               {renderError("postOffice")} */}
//               <label>Post Office</label>
//               <select
//                 name="postOffice"
//                 value={formData.postOffice || ""}
//                 onChange={handlePostOfficeSelect}
//               >
//                 <option value="">Select Post Office</option>
//                 {postOfficeList.map((p) => (
//                   <option key={p.Name} value={p.Name}>
//                     {p.Name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label>Bank Account</label>
//               <input
//                 name="bankAccount"
//                 value={formData.bankAccount || ""}
//                 onChange={handleChange}
//                 className={classErr("bankAccount")}
//               />
//               {renderError("bankAccount")}
//             </div>

//             <div>
//               <label>IFSC</label>
//               <input
//                 name="ifsc"
//                 placeholder="HDFC0001234 (optional)"
//                 value={formData.ifsc || ""}
//                 onChange={handleChange}
//                 className={classErr("ifsc")}
//               />
//               {/* <input
//                 name="ifsc"
//                 value={formData.ifsc || ""}
//                 onChange={(e) => setFormData((p) => ({ ...p, ifsc: e.target.value.toUpperCase() }))}
//                 className={classErr("ifsc")}
//                 placeholder="HDFC0001234 (optional)"
//               /> */}
//               {renderError("ifsc")}
//             </div>

//             <div>
//               <label>Bank Branch</label>
//               <input name="bankBranch" value={formData.bankBranch || ""} />
//             </div>

//             <div>
//               <label>Bank Name</label>
//               <input name="bankName" value={formData.bankName || ""} />
//             </div>
//           </div>
//         </section>

//         {/* Address */}
//         <section className="form-section">
//           <h3 className="section-title">Address</h3>
//           <div className="form-grid">
//             <div>
//               <label>Sub District</label>
//               <input
//                 name="subDistrict"
//                 value={formData.subDistrict || ""}
//                 onChange={handleChange}
//               />
//             </div>

//             <div>
//               <label>District</label>
//               <input
//                 name="district"
//                 value={formData.district || ""}
//                 onChange={handleChange}
//               />
//               {renderError("district")}
//             </div>

//             <div>
//               <label>State</label>
//               <input
//                 name="state"
//                 value={formData.state || ""}
//                 onChange={handleChange}
//               />
//               {renderError("state")}
//             </div>

//             <div>
//               <label>Country</label>
//               <input
//                 name="country"
//                 value={formData.country || ""}
//                 onChange={handleChange}
//               />
//               {renderError("country")}
//             </div>

//             <div>
//               <label>Full Address</label>
//               <textarea
//                 name="address"
//                 value={formData.address || ""}
//                 onChange={handleChange}
//                 placeholder="Enter full address"
//               />
//             </div>
//           </div>
//         </section>

//         {/* Other Details */}
//         <section className="form-section">
//           <h3 className="section-title">Other Details</h3>
//           <div className="form-grid">
//             <div>
//               <label>Marital Status</label>
//               <select
//                 name="maritalStatus"
//                 value={formData.maritalStatus || ""}
//                 onChange={handleChange}
//               >
//                 <option value="">Select</option>
//                 <option>Single</option>
//                 <option>Married</option>
//                 <option>Other</option>
//               </select>
//             </div>

//             <div>
//               <label>Date of Birth</label>
//               <input
//                 type="date"
//                 name="dob"
//                 value={formData.dob || ""}
//                 onChange={handleChange}
//               />
//               {renderError("dob")}
//             </div>

//             <div>
//               <label>Date of Joining</label>
//               <input
//                 type="date"
//                 name="doj"
//                 value={formData.doj || ""}
//                 onChange={handleChange}
//               />
//               {renderError("doj")}
//             </div>
//           </div>
//         </section>

//         <div className="form-actions">
//           <button
//             type="button"
//             className="btn-submit"
//             onClick={handleSubmit}
//             disabled={loadingSubmit}
//           >
//             {loadingSubmit ? (
//               <>
//                 <FaSpinner className="spin" /> Submitting...
//               </>
//             ) : (
//               "Submit"
//             )}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default CustomerForm;



import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getBranches,
  fetchRoles,
  submitCustomer,
} from "../redux/slices/Customer/CreateCustomerSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import "../assets/css/customerForm.css";
import { FaCheckCircle, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import { fetchCompanyAssignedApis } from "../redux/slices/assignedApiSlice";
import { fetchKey } from "../redux/slices/keySlice";

const fetchAddressByPincode = async (pincode) => {
  if (!/^\d{6}$/.test(pincode)) return null;

  try {
    const res = await fetch(
      `https://payyug.in/api/customer/pincode/${pincode}`,
    );

    const response = await res.json();

    console.log("PINCODE RESPONSE:", response);

    // ✅ Get PostOffice array
    const offices = response?.PostOffice;

    // ✅ Validate response
    if (!offices || offices.length === 0) {
      return null;
    }

    return {
      postOfficeList: offices,
      district: offices[0]?.District || "",
      subDistrict: offices[0]?.Block || "",
      state: offices[0]?.State || "",
      country: offices[0]?.Country || "",
    };
  } catch (error) {
    console.log("Pincode Fetch Error:", error);

    return null;
  }
};

const fetchBankByIFSC = async (ifsc) => {
  if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) return null;
  try {
    const res = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
    if (!res.ok) return null;
    const data = await res.json();
    // console.log("bank details;",data)
    return { bankName: data.BANK, bankBranch: data.BRANCH };
  } catch {
    return null;
  }
};

const CustomerForm = () => {
  const dispatch = useDispatch();
  const { branches, roles, loadingSubmit } = useSelector(
    (state) => state.customer,
  );
  const { profile } = useSelector((state) => state.userProfile);
  const { keyData } = useSelector((state) => state.key);
  const { assignedApis } = useSelector((state) => state.assignedApi || {});

  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [firstErrorField, setFirstErrorField] = useState(null);
  const [postOfficeList, setPostOfficeList] = useState([]);
  const [verifying, setVerifying] = useState({
    panNumber: false,
    aadhaarNumber: false,
  });

  const [verified, setVerified] = useState({
    panNumber: false,
    aadhaarNumber: false,
  });

  const firstErrorRef = useRef(null);

  useEffect(() => {
    dispatch(getBranches());
    dispatch(fetchRoles());
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // fetch assigned apis
  useEffect(() => {
    if (profile?.superAdminId) {
      dispatch(fetchKey(profile.superAdminId));
      dispatch(fetchCompanyAssignedApis(profile.superAdminId));
    }
  }, [dispatch, profile?.superAdminId]);

  useEffect(() => {
    // scroll to the first error when firstErrorField changes
    if (firstErrorField && firstErrorRef.current) {
      firstErrorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [firstErrorField]);

  // helper function for check specific assign apis active or not
  const isServiceActive = (serviceKey) => {
    const service = assignedApis?.find(
      (item) => item?.serviceName?.toLowerCase() === serviceKey.toLowerCase(),
    );
    return Boolean(
      service &&
      (service.isEnabled === true ||
        String(service.status).toLowerCase() === "active"),
    );
  };

  const isPanActive = isServiceActive("PAN_API");
  const isAadhaarActive = isServiceActive("AADHAR_API");

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // restrictions
    if (name === "pincode" && value.length > 6) return;
    if (name === "mobileNumber" && value.length > 10) return;
    if (name === "aadhaarNumber" && value.length > 12) return;
    if (name === "panNumber" && value.length > 10) return;
    if (name === "voterId" && value.length > 10) return;

    // ❗ Fields you want in uppercase
    const upperCaseFields = [
      "panNumber",
      "voterId",
      "ifsc",
      "fullName",
      "guardianName",
      "district",
      "state",
      "country",
      "subDistrict",
      "bankName",
      "bankBranch",
      "address",
    ];

    const val = upperCaseFields.includes(name) ? value.toUpperCase() : value;

    setFormData((p) => ({ ...p, [name]: val }));

    // PINCODE AUTO
    if (name === "pincode" && val.length === 6) {
      const addr = await fetchAddressByPincode(val);
      if (addr) {
        setPostOfficeList(addr.postOfficeList);
        setFormData((p) => ({
          ...p,
          district: addr.district.toUpperCase(),
          state: addr.state.toUpperCase(),
          country: addr.country.toUpperCase(),
          subDistrict: addr.subDistrict?.toUpperCase() || "",
          postOffice: "",
        }));
      }
    }

    // IFSC AUTO
    if (name === "ifsc") {
      const bank = await fetchBankByIFSC(val);
      setFormData((p) => ({
        ...p,
        bankName: bank?.bankName?.toUpperCase() || "",
        bankBranch: bank?.bankBranch?.toUpperCase() || "",
      }));
    }
  };

  const handlePostOfficeSelect = (e) => {
    setFormData((p) => ({ ...p, postOffice: e.target.value }));
  };

  // Validation
  const validateForm = () => {
    const newErr = {};

    // Voter Id
    if (
      formData.voterId &&
      !/^[A-Z]{3}[0-9]{7}$/.test(formData.voterId.trim())
    ) {
      newErr.voterId = "Voter ID must be 3 letters followed by 7 digits (e.g. ABC1234567)";
    }

    // PAN: 5 letters + 4 digits + 1 letter
    if (
      formData.panNumber &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(formData.panNumber.trim())
    ) {
      newErr.panNumber = "Enter a valid PAN (format: ABCDE1234F).";
    }

    // Aadhaar: 12 digits and should not start with 0 or 1
    if (
      !formData.aadhaarNumber ||
      !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber.trim())
    )
      newErr.aadhaarNumber =
        "Enter a valid Aadhaar (12 digits, cannot start with 0 or 1).";

    // IFSC: optional but validate if present
    if (formData.ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc.trim()))
      newErr.ifsc = "Invalid IFSC code.";

    // Mobile: Indian mobile (starts with 6-9 and 10 digits)
    if (
      !formData.mobileNumber ||
      !/^[6-9][0-9]{9}$/.test(formData.mobileNumber.trim())
    )
      newErr.mobileNumber =
        "Enter a valid 10-digit mobile number (starts with 6-9).";

    // Bank account: optional but validate if present (9-18 digits)
    if (
      formData.bankAccount &&
      !/^[0-9]{9,18}$/.test(formData.bankAccount.trim())
    )
      newErr.bankAccount = "Enter valid bank account number (9-18 digits).";

    // Pincode: required and 6 digits
    if (!formData.pincode || !/^[0-9]{6}$/.test(formData.pincode.trim()))
      newErr.pincode = "Enter a valid 6-digit pincode.";

    // Required textual fields
    const requiredFields = [
      "fullName",
      "guardianName",
      "district",
      "state",
      "country",
      "dob",
      // "doj",
    ];
    requiredFields.forEach((f) => {
      if (!formData[f] || String(formData[f]).trim() === "")
        newErr[f] = "Required field.";
    });

    // Email: optional but validate format if provided
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email.trim()))
      newErr.email = "Enter a valid email.";

    setErrors(newErr);

    if (Object.keys(newErr).length) {
      setFirstErrorField(Object.keys(newErr)[0]);
      return false;
    }

    // no errors
    setFirstErrorField(null);
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const payload = {
      ...formData,
      branchId: profile?.id || formData.branchId || 1,
      branchName: formData.branch || "",
      superAdminId: profile?.superAdminId || 1,
      role: "Customer",
      roleName: "Customer",
      bankIFSC: formData.ifsc || null,
      dateOfBirth: formData.dob,
      dateOfJoining: formData.doj||new Date().toISOString().split("T")[0],
      password: "123456",
      pin: "1234",
    };

    // Clean up unused fields
    delete payload.ifsc;
    delete payload.branch;
    delete payload.dob;
    delete payload.doj;

    try {
      // ⬅ 1. Submit customer API
      const result = await dispatch(submitCustomer(payload)).unwrap();

      toast.success("✅ Customer submitted successfully!");
      console.log("Response:", result);

      // Extract required fields for SMS
      const { fullName, userId, mobileNumber } = result?.data || result;

      // Reset Form after success
      setFormData({
        panNumber: "",
        aadhaarNumber: "",
        voterId:"",
        branch: "",
        title: "",
        gender: "",
        fullName: "",
        guardianName: "",
        mobileNumber: "",
        email: "",
        pincode: "",
        postOffice: "",
        bankAccount: "",
        ifsc: "",
        bankBranch: "",
        bankName: "",
        subDistrict: "",
        district: "",
        state: "",
        country: "",
        address: "",
        maritalStatus: "",
        dob: "",
        doj: "",
      });

      setErrors({});
      setFirstErrorField(null);
    } catch (err) {
      console.error("❌ Error submitting customer:", err);

      const msg = err?.message || err || "Failed to submit customer";
      alert(msg);
    }
  };

  const classErr = (f) => (errors[f] ? "CreateEmployee-input-error" : "");
  const renderError = (f) =>
    errors[f] ? (
      <p
        className="CreateEmployee-error-text"
        // attach ref only to the first error's element so scrollIntoView works
        ref={firstErrorField === f ? firstErrorRef : null}
      >
        {errors[f]}
      </p>
    ) : null;

  // Fetch Report Data using Client ID and Auto-fill
  const handleFetchAndFillAadhaar = useCallback(
    async (clientId) => {
      const activeClientId =
        clientId || sessionStorage.getItem("active_digilocker_client_id");

      if (!activeClientId) {
        toast.error("Client ID missing! Please re-verify on DigiLocker.");
        return;
      }

      setVerifying((p) => ({ ...p, aadhaarNumber: true }));

      try {
        const payload = { client_id: activeClientId };

        const res = await axios.post(
          "https://payyug.in/api/download/aadhar-details",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "x-secret-key": `${keyData?.secretKeyHash || ""}`,
              "x-api-key": `${keyData?.apiKey || ""}`,
            },
          },
        );

        const resData = res?.data;
        const isApiSuccess =
          resData?.success === true ||
          resData?.status === "SUCCESS" ||
          resData?.statusCode === 200 ||
          resData?.code === 200 ||
          resData?.data?.status === "SUCCESS";

        if (isApiSuccess) {
          const payloadRoot = resData?.data?.data || resData?.data || {};
          const xmlData = payloadRoot?.aadhaar_xml_data || {};
          const metaData = payloadRoot?.digilocker_metadata || {};

          const cleanGuardianName = (rawCareOf) => {
            if (!rawCareOf) return "";
            return rawCareOf
              .replace(/^(C\/O|S\/O|D\/O|W\/O|H\/O|B\/O)[:\s-]*/i, "")
              .trim();
          };

          // Extract fields
          const fullName = xmlData?.full_name || metaData?.name || "";
          const dob = xmlData?.dob || metaData?.dob || "";
          const rawGender = xmlData?.gender || metaData?.gender || "";
          const guardian = cleanGuardianName(xmlData?.care_of);
          const fullAddress = xmlData?.full_address || "";
          // const zip = xmlData?.zip || "";
          // const district = xmlData?.address?.dist || xmlData?.address?.city || "";
          // const state = xmlData?.address?.state || "";
          // const country=xmlData?.address?.country||"";
          // const post=xmlData?.address?.po||"";
          const mobile = metaData?.mobile_number || "";

          // Normalize Gender (M/F -> Male/Female)
          const mappedGender =
            rawGender === "M" || rawGender?.toLowerCase() === "male"
              ? "Male"
              : rawGender === "F" || rawGender?.toLowerCase() === "female"
                ? "Female"
                : "";

          // Form fields auto-fill
          setFormData((prev) => ({
            ...prev,
            fullName: fullName || prev?.fullName,
            dob: dob || prev?.dob,
            gender: mappedGender || prev?.gender,
            guardianName: guardian || prev?.guardianName,
            address: fullAddress || prev?.address,
            mobileNumber: mobile || prev?.mobileNumber,
            // pincode: zip || prev?.pincode,
            // postOffice:post||prev?.postOffice,
            // district: district ? district.toUpperCase() : prev?.district,
            // state: state ? state.toUpperCase() : prev?.state,
            // country: country?country.toUpperCase():prev?.country,
          }));

          setVerified((p) => ({ ...p, aadhaarNumber: true }));
          toast.success(
            "Aadhaar verified and details auto-filled successfully! ✅",
          );

          // Cleanup session
          sessionStorage.removeItem("active_digilocker_client_id");
          sessionStorage.removeItem("digilocker_pending");
        } else {
          const errMsg =
            resData?.message?.message ||
            resData?.message ||
            "Verification incomplete or processing.";
          toast.error(errMsg);
        }
      } catch (err) {
        console.error("Aadhaar Download API Error:", err);
        const errMsg =
          err?.response?.data?.message?.message ||
          err?.response?.data?.message ||
          "Verification incomplete or Client ID expired.";
        toast.error(errMsg);
      } finally {
        setVerifying((p) => ({ ...p, aadhaarNumber: false }));
      }
    },
    [keyData],
  );

  useEffect(() => {
    const handleFocus = () => {
      const isPending = sessionStorage.getItem("digilocker_pending");
      const clientId = sessionStorage.getItem("active_digilocker_client_id");

      if (isPending === "true" && clientId && !verified.aadhaarNumber) {
        handleFetchAndFillAadhaar(clientId);
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [handleFetchAndFillAadhaar, verified.aadhaarNumber]);

  // verify adhar
  const handleVerifyAadhaar = async () => {
    if (
      !formData.aadhaarNumber ||
      !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber)
    ) {
      toast.warn("Please enter a valid 12-digit Aadhaar number");
      return;
    }

    if (!keyData?.apiKey || !keyData?.secretKeyHash) {
      toast.error("API Keys missing or invalid. Please check settings.");
      return;
    }

    const newTab = window.open("about:blank", "_blank");
    setVerifying((p) => ({ ...p, aadhaarNumber: true }));

    try {
      const payload = {
        id_number: formData.aadhaarNumber,
        redirect_url: "https://payyug.in/api/aadhaar-details/callback",
        customerId: 1,
        employeId: profile?.id || 5,
      };

      const response = await axios.post(
        "https://payyug.in/api/apicheck/aadhar-details",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "x-secret-key": `${keyData.secretKeyHash}`,
            "x-api-key": `${keyData.apiKey}`,
          },
        },
      );

      const resData = response?.data;
      const redirectUrl = resData?.data?.data?.url || resData?.data?.url;
      const extractedClientId =
        resData?.data?.data?.client_id || resData?.data?.client_id;

      if (redirectUrl) {
        if (extractedClientId) {
          sessionStorage.setItem(
            "active_digilocker_client_id",
            extractedClientId,
          );
        }
        sessionStorage.setItem("digilocker_pending", "true");

        if (newTab && !newTab.closed) {
          newTab.location.href = redirectUrl;
        } else {
          window.location.href = redirectUrl;
        }

        toast.info("DigiLocker tab opened. Complete verification there.");
      } else {
        if (newTab) newTab.close();
        toast.error(
          resData?.message || "Failed to generate DigiLocker redirect URL.",
        );
      }
    } catch (err) {
      if (newTab) newTab.close();
      console.error("Initiate API Error:", err);
      toast.error(
        err?.response?.data?.message ||
          "Something went wrong while initiating verification.",
      );
    } finally {
      setVerifying((p) => ({ ...p, aadhaarNumber: false }));
    }
  };

  // verify pan
  const handleVerifyPan = async () => {
    if (
      !formData.panNumber ||
      !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panNumber)
    ) {
      toast.warn("Invalid PAN format");
      return;
    }

    if (!keyData?.apiKey || !keyData?.secretKeyHash) {
      toast.error(
        "API Keys missing or invalid. Please check your account settings.",
      );
      return;
    }

    setVerifying((p) => ({ ...p, panNumber: true }));

    try {
      const payload = {
        id_number: formData.panNumber,
        document_type: "PAN Comprehensive",
        customerId: 10,
        employeId: profile?.id,
      };

      const response = await axios.post(
        "https://payyug.in/api/apicheck/pan-details",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "x-secret-key": keyData.secretKeyHash,
            "x-api-key": keyData.apiKey,
          },
        },
      );

      const resBody = response?.data;
      const panInfo = resBody?.data?.data;

      if (resBody?.success && panInfo) {
        const mappedGender =
          panInfo.gender === "M"
            ? "Male"
            : panInfo.gender === "F"
              ? "Female"
              : (prev) => prev?.gender;

        setFormData((prev) => ({
          ...prev,
          fullName: panInfo.full_name || prev?.fullName,
          dob: panInfo.dob || prev?.dob,
          gender:
            typeof mappedGender === "function"
              ? mappedGender(prev)
              : mappedGender,
          address: panInfo.address?.full || prev?.address,
          // pincode: panInfo.address?.zip || prev?.pincode,
          // district: panInfo.address?.city?.toUpperCase() || prev?.district,
          // state: panInfo.address?.state?.toUpperCase() || prev?.state,
          // country: panInfo.address?.country?.toUpperCase() || prev?.country,
        }));

        setVerified((p) => ({ ...p, panNumber: true }));
        toast.success(resBody?.message || "PAN Verified Successfully");
      } else {
        toast.error(resBody?.message || "No data found for this PAN.");
      }
    } catch (error) {
      console.error("PAN Error:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong while verifying PAN.",
      );
    } finally {
      setVerifying((p) => ({ ...p, panNumber: false }));
    }
  };

  return (
    <div className="CustomerForm-wrapper">
      <form className="CustomerForm" onSubmit={(e) => e.preventDefault()}>
        <h2 className="form-title">Create New Customer</h2>
        {/* <div className="verify-btns-wrapper">
          <button className="">Verify Pan</button>
          <button className="" onClick={handleVerifyAdhar}>Verify Aadhar</button>
        </div> */}

        {/* Personal Info */}
        <section className="form-section">
          <h3 className="section-title">Personal Information</h3>

          <div className="form-grid-2">
            <div className="verify-wrapper">
              <label>PAN Number</label>
              <div className="verify-input-group">
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber || ""}
                  onChange={handleChange}
                  placeholder="Enter PAN Number"
                />
                {isPanActive && (
                  <button
                    type="button"
                    className="verify-btn"
                    onClick={handleVerifyPan}
                    disabled={
                      !formData.panNumber ||
                      verifying.panNumber ||
                      verified.panNumber
                    }
                  >
                    {verifying.panNumber ? (
                      <FaSpinner className="spin" />
                    ) : verified.panNumber ? (
                      "Verified ✅"
                    ) : (
                      <>
                        <FaCheckCircle /> Verify
                      </>
                    )}
                  </button>
                )}
              </div>
              {renderError("panNumber")}
            </div>

            <div className="verify-wrapper">
              <label>Aadhaar Number</label>
              <div className="verify-input-group">
                <input
                  type="text"
                  name="aadhaarNumber"
                  value={formData.aadhaarNumber || ""}
                  onChange={handleChange}
                  placeholder="Enter Aadhaar Number"
                  disabled={verified.aadhaarNumber}
                />
                {isAadhaarActive && (
                  <button
                    type="button"
                    className="verify-btn"
                    onClick={
                      sessionStorage.getItem("digilocker_pending") === "true"
                        ? () => handleFetchAndFillAadhaar()
                        : handleVerifyAadhaar
                    }
                    disabled={
                      !formData.aadhaarNumber ||
                      verifying.aadhaarNumber ||
                      verified.aadhaarNumber
                    }
                  >
                    {verifying.aadhaarNumber ? (
                      <>
                        <FaSpinner className="spin" /> Verifying...
                      </>
                    ) : verified.aadhaarNumber ? (
                      "Verified ✅"
                    ) : sessionStorage.getItem("digilocker_pending") ===
                      "true" ? (
                      "Fetch & Fill Data"
                    ) : (
                      <>
                        <FaCheckCircle /> Verify
                      </>
                    )}
                  </button>
                )}
              </div>
              {renderError("aadhaarNumber")}
            </div>
          </div>

          <div className="form-grid-4">
            <div>
             <label>Voter Id</label>
              <input
                name="voterId"
                value={formData.voterId || ""}
                onChange={handleChange}
                className={classErr("voterId")}
              />
              {renderError("voterId")}
            </div>
            <div>
              <label>Title</label>
              <select
                name="title"
                value={formData.title || ""}
                onChange={handleChange}
              >
                <option value="">Select Title</option>
                <option>Mr.</option>
                <option>Mrs.</option>
                <option>Ms.</option>
                <option>Miss</option>
                <option>Dr.</option>
              </select>
            </div>

            <div>
              <label>Gender</label>
              <select
                name="gender"
                value={formData.gender || ""}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>
          </div>
        </section>

        {/* Contact & Banking */}
        <section className="form-section">
          <h3 className="section-title">Contact & Banking</h3>
          <div className="form-grid">
            <div>
              <label>Full Name</label>
              <input
                name="fullName"
                value={formData.fullName || ""}
                onChange={handleChange}
                className={classErr("fullName")}
              />
              {renderError("fullName")}
            </div>

            <div>
              <label>Guardian/Father/husband/CareOf Name</label>
              <input
                name="guardianName"
                value={formData.guardianName || ""}
                onChange={handleChange}
                className={classErr("guardianName")}
              />
              {renderError("guardianName")}
            </div>

            <div>
              <label>Mobile Number</label>
              <input
                name="mobileNumber"
                value={formData.mobileNumber || ""}
                maxLength="10"
                onChange={handleChange}
                className={classErr("mobileNumber")}
              />
              {renderError("mobileNumber")}
            </div>

            <div>
              <label>Email ID</label>
              <input
                name="email"
                type="email"
                value={formData.email || ""}
                onChange={handleChange}
                className={classErr("email")}
              />
              {renderError("email")}
            </div>

            <div>
              <label>Pin Code</label>
              <input
                name="pincode"
                maxLength="6"
                value={formData.pincode || ""}
                onChange={handleChange}
                className={classErr("pincode")}
              />
              {renderError("pincode")}
            </div>

            <div>
              {/* <label>Post Office</label>
              <input name="postOffice" value={formData.postOffice || ""} onChange={handleChange} />
              {renderError("postOffice")} */}
              <label>Post Office</label>
              <select
                name="postOffice"
                value={formData.postOffice || ""}
                onChange={handlePostOfficeSelect}
              >
                <option value="">Select Post Office</option>
                {postOfficeList.map((p) => (
                  <option key={p.Name} value={p.Name}>
                    {p.Name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label>Bank Account</label>
              <input
                name="bankAccount"
                value={formData.bankAccount || ""}
                onChange={handleChange}
                className={classErr("bankAccount")}
              />
              {renderError("bankAccount")}
            </div>

            <div>
              <label>IFSC</label>
              <input
                name="ifsc"
                placeholder="HDFC0001234 (optional)"
                value={formData.ifsc || ""}
                onChange={handleChange}
                className={classErr("ifsc")}
              />
              {/* <input
                name="ifsc"
                value={formData.ifsc || ""}
                onChange={(e) => setFormData((p) => ({ ...p, ifsc: e.target.value.toUpperCase() }))}
                className={classErr("ifsc")}
                placeholder="HDFC0001234 (optional)"
              /> */}
              {renderError("ifsc")}
            </div>

            <div>
              <label>Bank Branch</label>
              <input name="bankBranch" value={formData.bankBranch || ""} />
            </div>

            <div>
              <label>Bank Name</label>
              <input name="bankName" value={formData.bankName || ""} />
            </div>
          </div>
        </section>

        {/* Address */}
        <section className="form-section">
          <h3 className="section-title">Address</h3>
          <div className="form-grid">
            <div>
              <label>Sub District</label>
              <input
                name="subDistrict"
                value={formData.subDistrict || ""}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>District</label>
              <input
                name="district"
                value={formData.district || ""}
                onChange={handleChange}
              />
              {renderError("district")}
            </div>

            <div>
              <label>State</label>
              <input
                name="state"
                value={formData.state || ""}
                onChange={handleChange}
              />
              {renderError("state")}
            </div>

            <div>
              <label>Country</label>
              <input
                name="country"
                value={formData.country || ""}
                onChange={handleChange}
              />
              {renderError("country")}
            </div>

            <div>
              <label>Full Address</label>
              <textarea
                name="address"
                value={formData.address || ""}
                onChange={handleChange}
                placeholder="Enter full address"
              />
            </div>
          </div>
        </section>

        {/* Other Details */}
        <section className="form-section">
          <h3 className="section-title">Other Details</h3>
          <div className="form-grid">
            <div>
              <label>Marital Status</label>
              <select
                name="maritalStatus"
                value={formData.maritalStatus || ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Single</option>
                <option>Married</option>
                <option>Other</option>
              </select>
            </div>

            <div>
              <label>Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={formData.dob || ""}
                onChange={handleChange}
              />
              {renderError("dob")}
            </div>

            <div>
              <label>Date of Joining</label>
              <input
                type="date"
                name="doj"
                value={formData.doj || ""}
                onChange={handleChange}
              />
              {renderError("doj")}
            </div>
          </div>
        </section>

        <div className="form-actions">
          <button
            type="button"
            className="btn-submit"
            onClick={handleSubmit}
            disabled={loadingSubmit}
          >
            {loadingSubmit ? (
              <>
                <FaSpinner className="spin" /> Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerForm;
